import { Suspense, lazy, useContext } from 'react'
import { WalletReadyContext } from '@/lib/walletContext'

const ColonyUsernameEditorInner = lazy(() => import('@/components/ColonyUsernameEditorInner'))

export default function ColonyUsernameEditor() {
  const walletReady = useContext(WalletReadyContext)
  if (!walletReady)
    return null
  return (
    <Suspense fallback={null}>
      <ColonyUsernameEditorInner />
    </Suspense>
  )
}
